import { render, staticRenderFns } from "./ps.vue?vue&type=template&id=d6bbc0d4&"
import script from "./ps.vue?vue&type=script&lang=js&"
export * from "./ps.vue?vue&type=script&lang=js&"
import style0 from "./ps.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports